import { API_HELPER } from '@/helpers/api.js';
import { authHeader } from '@/helpers/auth-header.js';

const GUIDES_API = 'Guides';

export const guidesService = {
  getList(input) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, GUIDES_API]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, input, requestOptions);
  },
  
  getById(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, GUIDES_API, id]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  create(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, GUIDES_API]);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  update(data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, GUIDES_API]);
    const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  },
  
  delete(id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, GUIDES_API, id]);
    const requestOptions = {
      method: 'DELETE',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions);
  }
};

